module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "append-to-body": "",
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    ref: "form"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "controls": "controls"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.image,
      "type": "video/mp4"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f3b57fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoShow.vue
// module id = 776
// module chunks = 2